<template>
  <div style="margin: 0 0 12px;">
    <div class="content-table" style="width: 100%;">
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          v-loading="listLoading"
          @cell-click="toggleSelection"
          size="default"
          style="width: 100%"
          border
          height="550"
      >
<!--        <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
        <el-table-column property="supplierName" label="供应商"/>
        <el-table-column property="brandName" label="品牌"/>
        <el-table-column property="commodityName" label="商品名称"/>
        <el-table-column property="" label="商品图片">
          <template #default="scope">
            <div v-if="scope.row.commodityImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
              <el-image class="item-img" fit="cover" :src="scope.row.commodityImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
            <div v-else>
              <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="" label="商品分类">
          <template #default="scope">
<!--            {{scope.row.commodityTypePreName}}{{scope.row.commodityTypeName}}-->
            {{scope.row.commodityTypePreName?scope.row.commodityTypePreName + '/':''}}{{scope.row.commodityTypeName}}
          </template>
        </el-table-column>
        <el-table-column property="specification" label="商品规格"/>
        <el-table-column property="measureUnitName" label="计量单位"/>
<!--        <el-table-column property="realNum" label="系统库存" class-name="cursor">-->
<!--          <template #default="scope">-->
<!--            <p style="color: #409eff">{{scope.row.realNum}}</p>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column property="currentStockNum" label="系统库存" class-name="cursor">
          <template #default="scope">
            <p style="color: #409eff">{{scope.row.currentStockNum}}</p>
          </template>
        </el-table-column>
        <el-table-column property="breakageNum" label="报损库存">
          <template #default="scope">
            <span v-if="scope.row.state == 3">{{scope.row.breakageNum?scope.row.breakageNum:'报损'}}</span>
            <span style="color: #409eff" class="btn-style" v-else @click="updateBreakage(scope.$index,scope.row)">{{scope.row.breakageNum?scope.row.breakageNum:'报损'}}</span>
          </template>
        </el-table-column>
        <el-table-column property="takeNum" label="盘点库存">
          <template #default="scope">
            <span v-if="scope.row.state == 3">{{scope.row.takeNum == -1?'盘点':scope.row.takeNum}}</span>
            <span style="color: #409eff" class="btn-style" v-else @click="updateTakeNum(scope.$index,scope.row)">{{scope.row.takeNum == -1?'盘点':scope.row.takeNum}}</span>
          </template>
        </el-table-column>

        <el-table-column property="" label="盘点图片" >
          <template #default="scope">
            <div v-if="scope.row.stockTakeImgList.length > 0" class="cursor" @click="takeImgList(scope.row)">
              <el-image class="item-img" fit="cover" :src="scope.row.stockTakeImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              <el-button v-if="scope.row.state != 3" size="small" @click.stop="fileUpdate(scope.$index,scope.row.id)">+ 添加</el-button>
            </div>
            <div v-else>
              <div v-if="scope.row.state != 3">
                <div class="add" @click="fileUpdate(scope.$index,scope.row.id)">
                  <span>+</span>
                </div>
              </div>
            </div>
            <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png,.heic"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">
          </template>
        </el-table-column>
        <el-table-column property="retailPrice" label="备注" width="200" class-name="cursor">
          <template #default="scope">
            <TakeRemark :userRemarkList="scope.row.stockTakeRemarkList" />
          </template>
        </el-table-column>
        <el-table-column property="" label="状态">
          <template #default="scope">
            <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待提交':scope.row.state == 1?'审核中':scope.row.state == 2?'不通过':scope.row.state == 3?'已通过':'' }}</p>
          </template>
        </el-table-column>
      </el-table>
<!--      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">-->
<!--      </el-pagination>-->
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 8px;" v-if="takeForm.state !=3">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>
</template>

<script>
import ImgViewer from "@/assets/js/imageViewer";
import {getFormData, postFormData} from "@/api/api";
import {listStockTakeCommodity, submitAuditStockTake, updatePurchaseState, listCommodityImg} from "@/api/url";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import TakeRemark from "@/components/StockTakeRemark/TakeRemark";
import Dialog from "@/assets/js/dialog";
import UserRemarkDialog from "@/components/Remark/UserRemarkDialog";
import TakeRemarkDialog from "@/components/StockTakeRemark/TakeRemarkDialog";
import UserImgUpload from "@/components/imgList/UserImgUpload";
import EditPriceNumDialog from "@/views/stock/components/EditPriceNumDialog";
import TakeBreakageDialog from "@/views/stock/components/TakeBreakageDialog";
import TakeNumDialog from "@/views/stock/components/TakeNumDialog";
import submitTakeDialog from "@/views/stock/components/submitTakeDialog";
import CommodityStockDialog from "@/views/stock/components/CommodityStockDialog";

export default {
  name: "StockListDialog",
  components: { TakeRemark },
    props: {
    value: Object
  },
  data() {
    return {
      takeForm: this.value.takeForm,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      idArray: [],

      batchLoading: false,


      uploadImgId: 0,
      uploadImgIdx: 0,

    }
  },
  methods: {

    //更改或添加
    fileUpdate(idx,id) {
      this.uploadImgIdx = idx
      this.uploadImgId = id
      this.$refs.file.setAttribute('type', 'file')
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      // console.log(this.$refs.file)
      if(e.target.files[0]) {
        let imgArr = []
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item};
          // this.imgArray.push(obj);
          imgArr.push(obj)
        }
        this.$refs.file.setAttribute('type', 'text')
        Dialog.open({
          title: '上传图片',
          component: UserImgUpload,
          data: {
            imgArray: imgArr,
            id: this.uploadImgId,
            width: '800px',
            from: 3,
          },
          confirm: (result) => {
            // this.getPage()
            this.getListCommodityImg()
            this.pageDataList[this.uploadImgIdx].state = 0

            // setTimeout(()=> {
            //
            // }, 500)
          }
        })
      }
    },

    getListCommodityImg() {
      getFormData(listCommodityImg, {id: this.uploadImgId}).then(data => {
        this.pageDataList[this.uploadImgIdx].stockTakeImgList = data.data
      })
    },


    cancel() {
      this.$emit("close");
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    userImgList(row) {
      let _title = '';
      _title = '商品图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.commodityImgList,
          id: row.commodityId,
          width: 908,
          from: 2,
          hideBtn: true
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    takeImgList(row) {
      let _title = '';
      _title = '盘点图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.stockTakeImgList,
          id: row.id,
          width: 908,
          from: 3,
          hideBtn: row.state == 3
        },
        confirm: (result) => {
          // this.getPage()
          row.stockTakeImgList = result
          row.state = 0
        }
      })
    },


    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '备注') {
        Dialog.open({
          title: '备注',
          component: TakeRemarkDialog,
          data: {
            id: row.id,
            width: '800px'
          },
          close: () => {
            row['stockTakeRemarkList'] = JSON.parse(sessionStorage.getItem('userLog'));
            // this.getPage()
          }
        })
      }

      //更新用户日志
      if(column.label == '系统库存') {
        let _title = '单品库存详情';
        let stockForm = Object.assign({}, row);
        stockForm.shopId = this.takeForm.shopId
        Dialog.open({
          title: _title,
          component: CommodityStockDialog,
          data: {
            stockForm: stockForm,
            // ids: idx,
            width: '1100px',
          },
          close: (result) => {
            this.getPage()
          }
        })
      }

    },

//盘点实存
    updateTakeNum(idx, row) {
      Dialog.open({
        title: '盘点库存',
        component: TakeNumDialog,
        data: {
          stockForm: row,
          width: '500px'
        },
        confirm: (result) => {
          // this.getPage()
          this.pageDataList[idx].state = 0
          this.pageDataList[idx].takeNum = result.takeNum
        }
      })
    },

//报损库存
    updateBreakage(idx, row) {
      Dialog.open({
        title: '报损库存',
        component: TakeBreakageDialog,
        data: {
          stockForm: row,
          width: '500px'
        },
        confirm: (result) => {
          // this.getPage()
          this.pageDataList[idx].state = 0
          this.pageDataList[idx].breakageNum = result.breakageNum
          this.pageDataList[idx].breakageRemark = result.breakageRemark
          this.pageDataList[idx].currentStockNum = this.pageDataList[idx].realNum - result.breakageNum
        }
      })
    },

    // //分页
    // handleCurrentChange(val) {
    //   this.currentPage = val;
    //   this.getPage();
    // },

    getPage() {
      this.searchLoading = true;
      this.listLoading = true;
      getFormData(listStockTakeCommodity, {id: this.takeForm.id}).then(data => {
        let {msg, code } = data;
        if(code == 200) {
          this.pageDataList = data['data'];
          this.pageDataList.map(item => {
            item.realNum = Number(item.currentStockNum) + Number(item.breakageNum)
          })
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      }).catch((response) => {
        this.searchLoading = false;
        this.listLoading = false;
      })
    },


    summit() {
      for(let i=0; i<this.pageDataList.length; i++) {
        if(this.pageDataList[i].takeNum == -1) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '存在未盘点的商品，无法提交',
            type: 'warning'
          });
          return false
        }
        if(this.pageDataList[i].state == 2) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: '存在审核不通过的商品，无法提交',
            type: 'warning'
          });
          return false
        }
      }
      Dialog.open({
        title: '盘点确认',
        component: submitTakeDialog,
        data: {
          id: this.takeForm.id,
          pageData: this.pageDataList,
          width: '500px'
        },
        confirm: (result) => {
          this.$emit('confirm')
        }
      })
    },


  },

  mounted() {
    this.getPage()
  }


}
</script>

<style scoped>
.stock-info{
  display: flex;
  align-items: center;
  justify-content: space-around;
  /*background-color: #f5f7fa;*/
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 24px;
}
.item-img {
  width: 56px;
  height: 56px;
}
.stock-info-img {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.stock-info-text {
  width: 25%;
}

.info-title{
  /*width: 70px;*/
  /*text-align: right;*/
  font-weight: bold;
}

.info-item {
  display: flex;
  align-items: center;
  margin: 3px 0;
}

.add {
  width: 56px;
  height: 56px;
  text-align: center;
  line-height: 56px;
  border: 1px dashed #ececec;
  font-size: 24px;
  cursor: pointer;
  float: left;
}

.btn-style {
  padding: 8px 0;
  cursor: pointer;
}

.btn-style:hover {
  text-decoration: underline;
}

</style>
